<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('products.productPlans.form.name')"
            is-required
            :error="errors.name"
        >
            <DInput
                id="name"
                v-model="form.name"
                :placeholder="__('products.productPlans.form.name')"
                :is-valid="isFormFieldValid('name')"
                maxlength="64"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.productPlans.form.targets.targets')"
            :error="errors.targets"
        >
            <DMultiSelect
                id="targets"
                :options="selectedTargetsOptions"
                :multiple="true"
                options-style="text"
                :is-valid="isFormFieldValid('targets')"
                @update="updateSelectedTargets"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.productPlans.runtime.label')"
            :is-required="true"
            :error="errors.runtime"
        >
            <DSelect
                id="runtime"
                v-model="form.runtime"
                :options="runtimes"
                :placeholder="__('products.productPlans.runtime.label')"
                :is-valid="isFormFieldValid('runtime')"
            />
        </DFormRow>
        <DFormRow
            v-if="form.runtime === 'limited'"
            :label="__('products.productPlans.runtime_in_month.label')"
            :is-required="true"
            :error="errors.runtime_in_month"
            :hint="__('products.productPlans.runtime_in_month.description')"
        >
            <DInput
                id="runtime_in_month"
                v-model="form.runtime_in_month"
                :placeholder="__('products.productPlans.runtime_in_month.label')"
                :is-valid="isFormFieldValid('runtime_in_month')"
                type="number"
                :min="1"
                :max="36"
            />
        </DFormRow>
        <DFormRow
            :label="__('products.productPlans.form.market_region_id')"
            :is-required="true"
            :error="errors.market_region_id"
        >
            <DSelect
                id="market_region_id"
                v-model="form.market_region_id"
                :options="marketRegions"
                :placeholder="__('products.productPlans.form.market_region_id')"
                :is-valid="isFormFieldValid('market_region_id')"
            />
        </DFormRow>
        <DFormControls
            v-model="form.activity_log_comment"
            :cancel-route="isAddon === false ? $route('products.products.show', productId) : $route('products.product-addons.show', productId)"
            :show-change-reason-input="true"
            @submit="submitForm"
        />
    </DForm>
</template>

<script>
export default {
    name: 'ProductPlanForm',
    props: {
        errors: {
            type: Object,
            default: () => { return {} }
        },
        productPlan: {
            type: Object,
            default: () => { return {} }
        },
        productId: {
            type: Number,
            default: 0
        },
        runtimes: {
            type: Array,
            default () {
                return []
            }
        },
        runtimeDefault: {
            type: String,
            default () {
                return ''
            }
        },
        isAddon: {
            type: Boolean,
            default () {
                return false
            }
        },
        marketRegions: {
            type: Array,
            default () {
                return []
            }
        },
        targetOptions: {
            type: Array,
            default () {
                return []
            }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                name: this.productPlan?.name ?? null,
                runtime: this.productPlan?.runtime ?? this.runtimeDefault,
                runtime_in_month: this.productPlan?.runtime_in_month ?? null,
                market_region_id: this.productPlan?.market_region_id ?? null,
                targets: this.productPlan?.targets ?? [],
                is_create: Object.keys(this.productPlan).length === 0,
                activity_log_comment: null
            })
        }
    },
    computed: {
        selectedTargetsOptions () {
            return this.targetOptions.map((option) => ({ ...option, selected: this.form.targets.includes(option.value) }))
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        },
        updateSelectedTargets (values) {
            this.form.targets = values
        }
    }
}
</script>
